export const check = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 17"
    width="23"
    height="17"
  >
    <path d="M7.374 12.242 19.544.545C19.924.182 20.405 0 20.99 0c.584 0 1.066.182 1.444.545.378.364.567.826.567 1.388 0 .562-.19 1.024-.567 1.388L8.818 16.405A2.018 2.018 0 0 1 7.374 17c-.55 0-1.03-.198-1.444-.595L.567 11.251C.19 10.887 0 10.425 0 9.863c0-.562.19-1.024.567-1.388.378-.363.86-.545 1.444-.545.585 0 1.066.182 1.444.545l3.92 3.767Z" />
  </svg>
);
